import { ProductTypeViewModel } from "./ProductTypeViewModel";

export interface SpecConstraintViewModel {
  id: number;
  key: string;
  displayName: string;
  valueType: SpecValueType;
  productTypeId?: number;
  productType?: ProductTypeViewModel | null;
  allowedValues?: SpecAllowedValueViewModel[] | null;
}

export interface SpecAllowedValueViewModel
{
    id: number;
    specConstraintId: number;
    specConstraint?: SpecConstraintViewModel | null;
    value: string;
}

export enum SpecValueType {
  Number = 0,
  String = 1,
  Enum = 2,
}